(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name auditReport.controller:AuditReportCtrl
   *
   * @description
   *
   */
  angular
    .module('userActivityAuditReport')
    .controller('UserActivityAuditReportCtrl', UserActivityAuditReportCtrl);

  function UserActivityAuditReportCtrl(crewScheduleService,CommonMasterData, $sce, CommonLogicService, UserActivityAuditReportService) {
    var vm = this;
    vm.ctrlName = 'UserActivityAuditReportCtrl';

    vm.model = {
      searchOnGoing: false,
      searchPanelToggle: true,
      initialSearchDone: false,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        auditTemplateGroup: null,
        auditTemplate: null,
        createdBy: null
      },
      masterList: {
        auditTemplateGroups: [],
        auditTemplateList : [],
        auditCreatedByList : [],
        fromDateAfterToDate : false,
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false
      },
      reportDataURL : null

    };

    vm.clickOnSearch = function (){
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.changeEditorField = function(searchParams,flag){
      switch (flag) {
        case "fromDate" :
          var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
          if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
            searchParams.toDate = tempFromDate;
          }
          validateDateFields();
          break;
        case "toDate" :
          validateDateFields();
          break;
        case "auditTemplateGroup":
          loadTemplateList(searchParams.auditTemplateGroup.name);
          break;
        default:
          break;
      }
    };

    function validateDateFields(){
      setDateValidationFlags();
      if(!!vm.model.searchCriteria.fromDate && !!vm.model.searchCriteria.toDate
        && !vm.model.masterList.fromDateFormatInvalid  && !vm.model.masterList.toDateFormatInvalid){
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        }else{
          vm.model.masterList.fromDateAfterToDate = false;
        }
      }
    };

    function setDateValidationFlags(){
      if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
        vm.model.masterList.fromDateFormatInvalid = true;
        vm.model.masterList.fromDateAfterToDate = false;
      }else{
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      if(isDateFormatInvalid(vm.model.searchCriteria.toDate)){
        vm.model.masterList.toDateFormatInvalid = true;
        vm.model.masterList.fromDateAfterToDate = false;
      }else{
        vm.model.masterList.toDateFormatInvalid = false;
      }
    };

    function isDateFormatInvalid(date){
      if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
        return true;
      }
      return false;
    };

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    function loadTemplateList(auditTemplateGroup) {
      if (!!auditTemplateGroup) {
        UserActivityAuditReportService.getAuditTemplateList(auditTemplateGroup, function (response) {
          vm.model.masterList.auditTemplateList = response;
        }, function () {
          console.log('Audit Template List error');
        });

      } else {
        vm.model.masterList.auditTemplateList = [];
      }
    };

    vm.searchByOptions = function (param){
      searchAuditReport(param);
    };

    function  searchAuditReport(param){
      vm.model.initialSearchDone = true;
      vm.model.searchPanelToggle = false;
      var rptDesign = "user_activity_audit_report.rptdesign";
      var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
      vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
    }

    function getSearchParamMap(param) {
       var searchParamMap = {};
       searchParamMap["fromDate"] = param.fromDate;
       searchParamMap["toDate"] = param.toDate;
       searchParamMap["referrer"] = window.location.origin;

       if(!nullOrEmpty(param.auditTemplateGroup)){
         searchParamMap["templateGroup"] = param.auditTemplateGroup.name;
       }

       if(!nullOrEmpty(param.auditTemplate)){
         searchParamMap["template"] = param.auditTemplate.name;
       }

       if (!!param.createdBy && param.createdBy.length>0) {
          searchParamMap["loginId"] = createCommaSeparatedString(param.createdBy,'loginId');
       }
       return searchParamMap;
    }

    function createCommaSeparatedString(list, valueFieldName) {
      if(list === null || list.length === 0 || angular.isUndefined(list)){
        return "";
      }

      var commaSeparatedString = '';
      for (var j = 0; j < list.length; j++) {
        var  obj = Object(list[j]);
        if (j == 0) {
          commaSeparatedString = obj[valueFieldName];
        } else {
          commaSeparatedString += ',' + obj[valueFieldName];
        }
      }
      return commaSeparatedString;
    }

    function nullOrEmpty(value){
      if(value === null || value == ""||angular.isUndefined(value)|| value == " "){
        return true;
      }
    }

    UserActivityAuditReportService.getAuditTemplateGroups(function (response) {
        vm.model.masterList.auditTemplateGroups = response;
      }, function () {
         console.log('Audit Template Group error');
      });

    UserActivityAuditReportService.getAuditCreatedByList(function(response) {
			vm.model.masterList.auditCreatedByList = response;
		}, function() {
			console.log('Audit Created By error');
	  });

  }
}());
